import { Controller } from "@hotwired/stimulus"

// Reopens Google's consent message (AdSense Privacy & messaging CMP) so a visitor can change
// or withdraw the choice made on the banner — GDPR: withdrawing must be as easy as accepting.
// docs/analytics/google-consent-mode.md
//
// Shows the `unavailable` target instead when there is no message to reopen: the CMP script did
// not load (ad blocker, or any environment but production), or GDPR does not apply to the visitor
// (Google only shows the message in the EEA, the UK and Switzerland).
export default class extends Controller {
  static targets = ["unavailable"]
  static values = { timeout: { type: Number, default: 2000 } }

  disconnect () {
    clearTimeout(this.timer)
  }

  open (event) {
    event.preventDefault()
    this.toggleUnavailable(false)
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.toggleUnavailable(true), this.timeoutValue)

    window.googlefc = window.googlefc || {}
    window.googlefc.callbackQueue = window.googlefc.callbackQueue || []
    window.googlefc.callbackQueue.push({
      CONSENT_DATA_READY: () => this.reopen()
    })
  }

  reopen () {
    clearTimeout(this.timer)

    if (typeof window.__tcfapi !== "function") {
      window.googlefc.showRevocationMessage()
      return
    }

    window.__tcfapi("getTCData", 2, (tcData, success) => {
      if (success && tcData.gdprApplies === false) {
        this.toggleUnavailable(true)
      } else {
        window.googlefc.showRevocationMessage()
      }
    })
  }

  toggleUnavailable (visible) {
    if (this.hasUnavailableTarget) this.unavailableTarget.hidden = !visible
  }
}
